import { render, staticRenderFns } from "./user-create-drawer.vue?vue&type=template&id=396998b6&"
import script from "./user-create-drawer.vue?vue&type=script&lang=js&"
export * from "./user-create-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports